exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".color-ball[data-v-46b753db]{cursor:pointer}.top-image[data-v-46b753db]{display:block;position:relative;padding-top:74.5%}.top-image img[data-v-46b753db]{border-radius:16px;position:absolute;top:0;left:0;width:100%;height:100%;-o-object-fit:cover;object-fit:cover;opacity:0;transition:opacity .7s ease-in-out 0s;mix-blend-mode:darken}.top-image img.current[data-v-46b753db]{opacity:1}", ""]);

// exports
